import React from 'react';
import PropTypes from 'prop-types';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import { connect } from 'react-redux';
import { setVisitedSubunitsAction } from '../state/actions';
import getIsExpanded from '../utils/getIsExpanded';

const getExpanderButtonProps = (isExpanded, subunitId) => {
  const expandedContent = `expanded-content-${subunitId}`;

  const commonAccessibility = {
    'aria-controls': expandedContent,
    'aria-expanded': isExpanded,
    'aria-label': 'Toggle resources visibility',
  };

  if (isExpanded) {
    return {
      icon: 'dropup_arrow',
      className: 'bg-blue-200',
      accessibility: {
        ...commonAccessibility,
      },
    };
  }

  return {
    icon: 'dropdown_arrow',
    accessibility: {
      ...commonAccessibility,
    },
  };
};

const Expander = ({
  expanderId,
  setVisitedSubunits,
  visitedSubunits,
  unitNumber,
  subjectId,
  userId,
  subunitId,
}) => {
  const isExpanded = getIsExpanded({
    visitedSubunits,
    key: [`${subjectId}-${userId}`, unitNumber],
    unitNumber,
    expanderId,
  });

  return (
    <ButtonWithIcon
      isIcon
      isNaked
      key={`button-expander-${expanderId}`}
      onClick={(event) => {
        event.stopPropagation();
        setVisitedSubunits({
          subjectId,
          userId,
          unitNumber,
          number: expanderId,
          isVisited: !isExpanded,
        });
      }}
      {...getExpanderButtonProps(isExpanded, subunitId)}
    />
  );
};

Expander.propTypes = {
  expanderId: PropTypes.string.isRequired,
  unitNumber: PropTypes.string.isRequired,
  subjectId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
};

export default connect(
  ({ visitedSubunits }) => ({
    visitedSubunits,
  }),
  {
    setVisitedSubunits: setVisitedSubunitsAction,
  },
)(Expander);
